import { Divider, Stack } from '@mui/material';
import { validateNotNullOrUndefined } from '@vy/utils';
import React from 'react';
import { useAccount } from '../../../../../hooks/requests/use-account';
import { useUsers } from '../../../../../hooks/requests/use-users';
import { withAccountForm } from './general-tab-content-components/AccountForm';
import { AccountInfoSection } from './general-tab-content-components/AccountInfoSection';
import { BankInfoSection } from './general-tab-content-components/BankInfoSection';

const GeneralTabContent: React.FC = () => {
  const accountQuery = useAccount({
    suspense: true,
  });
  validateNotNullOrUndefined(accountQuery.data);

  useUsers({ suspense: true });

  return (
    <Stack direction="column" divider={<Divider sx={{ marginY: '20px' }} />} sx={{
      paddingY: "20px"
    }}>
      <AccountInfoSection />
      <BankInfoSection />
    </Stack>
  );
};

const GeneralTabContentWithForm = withAccountForm(GeneralTabContent);
export { GeneralTabContentWithForm as GeneralTabContent };
